<script setup>
import { ref } from 'vue'

const props = defineProps({
    cat: Object,
    selectedCat: Number,
    dragOverCatId: Number,
    isDragging: Boolean,
})
const emit = defineEmits(['select', 'dragover', 'dragleave', 'drop'])

const open = ref(false)
const hasChildren = props.cat.children && props.cat.children.length > 0
</script>

<template>
    <li
        class="cat-node"
        :class="{
            'cat-node--active': cat.id === selectedCat,
            'cat-node--drop-target': isDragging && dragOverCatId === cat.id && cat.id !== selectedCat,
        }"
    >
        <div
            class="cat-node-row"
            @dragover.prevent="$emit('dragover', cat.id)"
            @dragleave.self="$emit('dragleave', cat.id)"
            @drop.prevent="$emit('drop', cat.id)"
        >
            <button
                type="button"
                class="cat-toggle"
                :style="{ visibility: hasChildren ? 'visible' : 'hidden' }"
                @click.stop="open = !open"
            >
                {{ open ? '▾' : '▸' }}
            </button>
            <a
                class="cat-label"
                href="#"
                style="text-decoration:none; color:inherit;"
                @click.prevent="$emit('select', cat.id)"
            >
                <span v-if="cat.code" class="cat-code">{{ cat.code }}</span>
                <span class="cat-title" :title="cat.title">{{ cat.title }}</span>
                <span class="cat-count-badge">{{ cat.totalCount }}</span>
            </a>
        </div>
        <ul v-if="hasChildren && open" class="cat-children">
            <MediaTreeNode
                v-for="child in cat.children"
                :key="child.id"
                :cat="child"
                :selected-cat="selectedCat"
                :drag-over-cat-id="dragOverCatId"
                :is-dragging="isDragging"
                @select="$emit('select', $event)"
                @dragover="$emit('dragover', $event)"
                @dragleave="$emit('dragleave', $event)"
                @drop="$emit('drop', $event)"
            />
        </ul>
    </li>
</template>
